/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import I18N from '@leverege/i18n';
import { Button, Content, Dialog, Flex, Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { LoadingView } from '@leverege/molten/views';
import MultiSelector from '../../views/salesFlow/components/MultiSelector';
import SearchRecipients from './SearchRecipients';
import S from './SendPendingSaleMessageScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.alerts.views.SendPendingSaleMessageScreen');
function SendPendingSaleMessageScreen(props) {
  const {
    showDialog,
    onClose,
    actions,
    // location item action
    combinedRecipients,
    setCombinedRecipients
  } = props;
  const [state, setState] = useState({
    pendingSaleMessageRecipients: combinedRecipients
  });
  const [activeDialog, setActiveDialog] = useState();
  useEffect(() => {
    if (!state?.pendingSaleMessageRecipientsTmp) {
      setState({
        pendingSaleMessageRecipients: combinedRecipients
      });
    }
  }, [combinedRecipients, state?.pendingSaleMessageRecipientsTmp]);

  // removes recipient from temporary list before submission
  const onRemoveRecipient = ({
    data
  }) => {
    setState({
      ...state,
      pendingSaleMessageRecipients: state.pendingSaleMessageRecipients.filter(r => r !== data)
    });
  };

  // update location with new recipients
  const onSubmit = async () => {
    const closeLoading = LoadingView.showDialog(t('loading'));
    const {
      pendingSaleMessageRecipients
    } = state;

    // sort the recipient by type, user, email, or phone
    const users = [];
    const emails = [];
    const phones = [];
    pendingSaleMessageRecipients.forEach(async recipient => {
      if (typeof recipient === 'object') {
        users.push(recipient);
      } else if (recipient.includes('@')) {
        emails.push(recipient.trim());
      } else if (typeof Number(recipient.replace(/\D/g, '')) === 'number') {
        // gets rid of any non digits
        phones.push(recipient.replace(/\D/g, ''));
      }
    });

    // updates recipients in location
    try {
      await GlobalState.dispatch(actions.update({
        data: [{
          path: 'pendingSaleAlerts/users',
          value: [users]
        }, {
          path: 'pendingSaleAlerts/emails',
          value: [emails]
        }, {
          path: 'pendingSaleAlerts/phones',
          value: [phones]
        }]
      }));
      setCombinedRecipients(pendingSaleMessageRecipients);
    } catch (err) {
      console.error('Could not update location with new pending sale alert recipients', err);
    }
    setState({
      ...state,
      pendingSaleMessageRecipientsTmp: null
    });
    closeLoading();
    onClose();
  };

  // sets active dialog box
  const goToDialog = dialog => () => {
    setActiveDialog(dialog);
  };

  // goes back to default dialog
  const onCancel = () => {
    setActiveDialog('default');
  };

  // exits out of the dialog and resets tmp array to remove added recipients
  const onExit = () => {
    setState({
      ...state,
      pendingSaleMessageRecipientsTmp: null
    });
    onClose();
  };

  // closes out all dialogs and resets active dialog back to the default
  const handleClose = () => {
    onClose();
    setActiveDialog('default');
  };

  // finalizes and replaces the pendingSaleMessageRecipients to the temp array thats set in the SearchRecipients function
  const onSearchSubmit = () => {
    setState({
      ...state,
      pendingSaleMessageRecipients: state.pendingSaleMessageRecipientsTmp
    });
    goToDialog('default')();
  };
  let body, footer;
  switch (activeDialog) {
    case 'searchRecipients':
      body = /*#__PURE__*/_jsx(SearchRecipients, {
        actions: actions,
        state: [state, setState],
        handleClose: handleClose,
        onCancel: onCancel,
        onSearchSubmit: onSearchSubmit,
        searchUsers: true,
        searchPhones: true,
        searchEmails: true
      });
      footer = /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "itemFormFooter|formButtons",
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          type: "button",
          onClick: handleClose,
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onSearchSubmit,
          children: t('apply')
        })]
      });
      break;
    default:
      body = /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "body",
          children: t('defaultContentMsg')
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bold",
            children: t('defaultSelectMsg')
          }), /*#__PURE__*/_jsx(Text, {
            variant: "body",
            children: t('defaultAddMsg')
          })]
        }), /*#__PURE__*/_jsx(MultiSelector, {
          values: state?.pendingSaleMessageRecipients,
          valueKey: "id",
          onAdd: goToDialog('searchRecipients'),
          onRemove: onRemoveRecipient
        })]
      });
      footer = /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "itemFormFooter|formButtons",
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          type: "button",
          onClick: onExit,
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onSubmit,
          children: t('done')
        })]
      });
  }
  return /*#__PURE__*/_jsx(Dialog, {
    classname: S.dialog,
    onClose: handleClose,
    show: showDialog,
    closeOnEscape: true,
    closeOnDocumentClick: true,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "itemFormHeader|formHeader",
        className: S.header,
        children: /*#__PURE__*/_jsxs(Flex, {
          direction: "row",
          align: "center",
          justify: "space-between",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "dialogTitle",
            icon: tIcon('defaultHeaderIcon'),
            imageOpts: {
              style: {
                height: '24px'
              }
            },
            children: t('defaultHeaderTitle')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            onClick: handleClose
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "itemFormBody|formBody",
        className: S.form,
        children: body
      }), footer]
    })
  });
}
export default SendPendingSaleMessageScreen;